// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"36":"Panier","389":"404","804":"liste","962":"home"}[chunkId] || chunkId) + "." + {"36":"d69b0a5b","277":"7ddcfbfd","389":"67b9e303","420":"f0122513","804":"6c847de1","962":"ec548057"}[chunkId] + ".css";
};